import { FormControl, Grid, InputAdornment, Stack, TextField, Typography } from "@mui/material";
import customStyles from "app/shared-components/SelectCustomStyle";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import CustomDatePicker from "../utilities/CustomDatePicker";
import moment from "moment";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import { forwardRef } from "react";
import { useImperativeHandle } from "react";
import { checkNumber } from "../utilities/FormValidation";

const LetterOfCreditForm = forwardRef((props, ref) => {
    const [successMsg, setSuccessMsg] = useState();
    const [validError, setValidError] = useState();
    const [companyOptions, setCompanyOptions] = useState([]);
    const [lcNumberOptions, setLcNumberOptions] = useState([]);
    const [saveDisabled, setSaveDisabled] = useState(true);
    const [editData, setEditData] = useState()
    const [orderCategoriesOptions, setOrderCategoriesOptions] = useState([
        { label: 'RETAIL', value: 'RETAIL' },
        { label: 'PROJECT', value: 'PROJECT' },
    ]);
    const [bankOption, setBankOptions] = useState([
        // { label: "HSBC", value: "HSBC" },
        // { label: "ENBD", value: "ENBD" },
        // { label: "HDFC", value: "HDFC" }
    ])
    const [usanceOption, setUsanceOptions] = useState([])
    const [ammendDisabled, setAmmendDisabled] = useState(false);

    const [lcData, setLcData] = useState({
        company: 0,
        companyName: "",
        orderType: "",
        documentCreditNo: "",
        dcAmount: '0.00',
        toleranceLevel: '0.000',
        toleranceAmount: '0.00',
        totalDCAmount: '0.00',
        dateOfIssue: "",
        expiryDate: "",
        lastDateOfShipment: "",
        bank: "",
        usance: 0,
        issuingBankName: "",
        bankAddress: "",
        bankIdentifierCode: ""
    })
    const companyUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;
    const AddlcUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.letterOfCredits}`;
    const lcUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.letterOfCredit}`;
    const usanceUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.usances}`;
    const bankUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.bankInfoes}`;

    const handleNameChange = (data) => {
        setLcData({ ...lcData, company: data.id, companyName: data.value })
    }
    const handleBankChange = (data) => {
        setLcData({ ...lcData, bank: data.value, bankAddress: data.bankAddress, bankIdentifierCode: data.bankIdentifierCode, issuingBankName: data.issuingBankName })
    }
    const handleUsanceChange = (data) => {
        setLcData({ ...lcData, usance: data.id })
    }

    const loadAmmendData = async (id) => {
        const selectedLc = await OAuthService.getList(lcUrl + `/${id}`);
        if (selectedLc?.data) {
            const newData = { ...selectedLc?.data, toleranceLevel: Number(selectedLc?.data?.toleranceLevel).toFixed(3), toleranceAmount: '0.00', dcAmount: '0.00', totalDCAmount: '0.00', usance: selectedLc?.data?.usance?.id };
            setLcData(newData);
            setAmmendDisabled(true)
        }
    }

    useEffect(() => {
        const companyList = async () => {
            const types = await OAuthService.getList(companyUrl + '/search/findByActive?active=true');
            let companyName = types?.data?._embedded?.companies.map((type) => {

                return { label: type.name, value: type.name, id: type.id }
            });
            if (companyName && companyName.length > 0) {
                setCompanyOptions(companyName)
            }
        }
        companyList();
        const usanceList = async () => {
            const types = await OAuthService.getList(usanceUrl + '/search/findByIsActive?b=true');
            let usances = types?.data?._embedded?.usances.map((type) => {

                return { label: type.description, value: type.noOfDays, idUrl: type._links.self.href, id: type._links.self.href.split('/').pop() }
            });
            if (usances && usances.length > 0) {
                setUsanceOptions(usances)
            }
        }
        usanceList();
        const bankList = async () => {
            const types = await OAuthService.getList(bankUrl);
            let banks = types?.data._embedded.bankInfoes.map((type) => {

                return { label: type.bank, value: type.bank, bankIdentifierCode: type.bankIdentifierCode, bankAddress: type.bankAddress, issuingBankName: type.issuingBankName }
            });
            if (banks && banks.length > 0) {
                setBankOptions(banks)
            }
        }
        bankList();

        const lcNoList = async () => {
            const list = await OAuthService.getList(lcUrl + '/getAllLcNumbers');
            if (list?.data) {
                const lcNo = list?.data?.map((val) => {

                    return { label: val, value: val }
                });
                if (lcNo.length > 0) {
                    setLcNumberOptions(lcNo)
                }
            }
        }

        if (props.type === 'Ammend') {
            lcNoList()
        }
        if (props.type === 'Ammend' && props.ammendId) {
            loadAmmendTopUpData(props.ammendId)
        } else if (props?.selectedRow && props?.selectedRow.length > 0 && !props.addSelected) {
            if (props.type === 'Ammend') {
                loadAmmendData(props?.selectedRow[0]?.documentCreditNo)
            } else {
                lcViewData(props?.selectedRow[0]?.documentCreditNo)
            }
        }
        if (props.lcId) {
            lcViewData(props.lcId)
        }


    }, [])

    const lcViewData = async (id) => {
        const selectedLc = await OAuthService.getList(lcUrl + `/${id}`);
        if (selectedLc?.data) {
            const newData = { ...selectedLc?.data, usance: selectedLc?.data?.usance?.id, 
            toleranceAmount: Number(selectedLc?.data?.toleranceAmount).toFixed(2),
            toleranceLevel: Number(selectedLc?.data?.toleranceLevel).toFixed(3),
            dcAmount: Number(selectedLc?.data?.dcAmount).toFixed(2),
            totalDCAmount: Number(selectedLc?.data?.totalDCAmount).toFixed(2),
            }
            setLcData(newData);
            setEditData({ ...selectedLc?.data, usance: selectedLc?.data?.usance?.id,
                toleranceAmount: Number(selectedLc?.data?.toleranceAmount).toFixed(2),
                toleranceLevel: Number(selectedLc?.data?.toleranceLevel).toFixed(3),
                dcAmount: Number(selectedLc?.data?.dcAmount).toFixed(2),
                totalDCAmount: Number(selectedLc?.data?.totalDCAmount).toFixed(2),
            })
        }
    }

    const loadAmmendTopUpData = async (id) => {
        const selectedLc = await OAuthService.getList(lcUrl + `/getTransaction?transactionId=${id}`);
        if (selectedLc?.data) {
            const newData = {
                ...selectedLc?.data,
                company: selectedLc?.data?.letterOfCredit.company,
                companyName: selectedLc?.data?.letterOfCredit.companyName,
                totalDCAmount: Number(Number(selectedLc?.data?.toleranceAmount) + Number(selectedLc?.data?.dcAmount)).toFixed(2),
                toleranceLevel: Number(selectedLc?.data?.letterOfCredit.toleranceLevel).toFixed(3),
                toleranceAmount: Number(selectedLc?.data?.toleranceAmount).toFixed(2),
                dcAmount: Number(selectedLc?.data?.dcAmount).toFixed(2),
                bank: selectedLc?.data?.letterOfCredit.bank,
                usance: selectedLc?.data?.letterOfCredit?.usance?.id,
                orderType: selectedLc?.data?.letterOfCredit.orderType,
                dateOfIssue: selectedLc?.data?.letterOfCredit.dateOfIssue,
                expiryDate: selectedLc?.data?.letterOfCredit.expiryDate,
                lastDateOfShipment: selectedLc?.data?.letterOfCredit.lastDateOfShipment,
                issuingBankName: selectedLc?.data?.letterOfCredit.issuingBankName,
                bankAddress: selectedLc?.data?.letterOfCredit.bankAddress,
                bankIdentifierCode: selectedLc?.data?.letterOfCredit.bankIdentifierCode,
                topUpTillDate: selectedLc?.data?.letterOfCredit.topUpTillDate,
                totalLcValue: selectedLc?.data?.letterOfCredit.totalLcValue,
                balance: selectedLc?.data?.letterOfCredit.balance,
                utilized: selectedLc?.data?.letterOfCredit.utilized,
                pending: selectedLc?.data?.letterOfCredit.pending,
                accepted: selectedLc?.data?.letterOfCredit.accepted,
                received: selectedLc?.data?.letterOfCredit.received,
                dateOfAmmendment: selectedLc?.data?.letterOfCredit.dateOfAmmendment,
                reConciled: selectedLc?.data?.letterOfCredit.reConciled,
                active: selectedLc?.data?.letterOfCredit.active,
                documentCreditNo: selectedLc?.data?.letterOfCredit.documentCreditNo,
                transactionId: id
            };
            delete newData.letterOfCredit;
            delete newData.lcNumber;
            delete newData.customerName;
            delete newData.transactionStatus;
            delete newData.principalLcValue;
            setLcData(newData);
            setEditData(JSON.parse(JSON.stringify(newData)))
            setAmmendDisabled(true)
        }
    }

    useEffect(() => {

        if (lcData.companyName && lcData.orderType && lcData.documentCreditNo && lcData.dcAmount && lcData.toleranceLevel &&
            lcData.dateOfIssue && lcData.expiryDate && lcData.lastDateOfShipment && lcData.bank && lcData.usance && lcData.issuingBankName &&
            lcData.bankAddress && lcData.bankIdentifierCode && !validError && new Date(lcData?.dateOfIssue) < new Date(lcData?.lastDateOfShipment) &&
            new Date(lcData?.dateOfIssue) < new Date(lcData?.expiryDate)) {
            if (lcData?.companyName !== editData?.companyName || editData?.orderType !== lcData.orderType || editData?.documentCreditNo !== lcData.documentCreditNo || Number(editData?.dcAmount) !== Number(lcData.dcAmount) || Number(editData?.toleranceLevel) !== Number(lcData.toleranceLevel) || editData?.dateOfIssue !==
                lcData.dateOfIssue || editData?.expiryDate !== lcData.expiryDate || editData?.lastDateOfShipment !== lcData.lastDateOfShipment || editData?.bank !== lcData.bank || editData?.usance !== lcData.usance || editData?.issuingBankName !== lcData.issuingBankName || editData?.bankAddress !==
                lcData.bankAddress || editData?.orderType !== lcData.orderType) {
                setSaveDisabled(false)
            } else {
                setSaveDisabled(true)
            }
        } else {
            setSaveDisabled(true)
        }
    }, [lcData, editData, validError])

    useEffect(() => {
        props.checkSaveDisabled(saveDisabled)
    }, [saveDisabled])

    const handleSubmit = async () => {
        let model = {
            ...lcData,
            usance: `${usanceUrl}/${lcData?.usance}`,
            dcAmount: Number(lcData.dcAmount),
            toleranceLevel: Number(lcData.toleranceLevel),
            toleranceAmount: Number(lcData.toleranceAmount),
            totalDCAmount: Number(lcData.totalDCAmount)
        }
        try {
            if (props.type === 'Ammend') {
                model = { ...model, usance: { id: model.usance } }
                if (props.type === 'Ammend' && props.ammendId) {
                    delete model.lcDocumentId;
                    await OAuthService.updateData(lcUrl + '/updateTransaction', '', model);
                    setSuccessMsg('LC updated successfully.')
                    return 'LC updated successfully.';
                } else {
                    await OAuthService.updateData(lcUrl + '/ammendment', '', model);
                    setSuccessMsg('LC updated successfully.')
                    return 'LC updated successfully.';
                }
            } else {
                if (props.addSelected) {
                    await OAuthService.addData(AddlcUrl, model);
                    setSuccessMsg('LC added successfully.')
                    return 'LC added successfully.';
                } else {
                    await OAuthService.updateData(AddlcUrl, lcData?.id, model);
                    setSuccessMsg('LC Updated successfully.')
                    return 'LC Updated successfully.';
                }
            }

        } catch (error) {

        }
    }

    const handleChangeToleranceLevel = (e) => {
        const newToleranceLevel = e.target.value;
        const newToleranceAmount = lcData.dcAmount * newToleranceLevel / 100;
        const newTotalDcAmount = Number(lcData.dcAmount) + Number(newToleranceAmount);

        setLcData({
            ...lcData,
            toleranceLevel: newToleranceLevel,
            toleranceAmount: Number(newToleranceAmount).toFixed(2),
            totalDCAmount: Number(newTotalDcAmount).toFixed(2)
        });
    }

    const handleDCAmountChange = (e) => {

        if (e.target.value && lcData.toleranceLevel) {
            const newToleranceAmount = e.target.value * lcData.toleranceLevel / 100;
            const newTotalDcAmount = Number(e.target.value) + Number(newToleranceAmount);

            setLcData({
                ...lcData,
                dcAmount: e.target.value,
                toleranceAmount: Number(newToleranceAmount).toFixed(2),
                totalDCAmount: Number(newTotalDcAmount).toFixed(2)
            });

        } else {
            setLcData({ ...lcData, dcAmount: e.target.value })
        }
    }

    useImperativeHandle(ref, () => ({
        handleSubmit: handleSubmit
    }))

    const handleOrderTypeChange = (data) => {
        setLcData({ ...lcData, orderType: data.value })
    }

    const handleLcChange = async (data) => {
        if (data.value) {
            loadAmmendData(data.value);
        }
    }

    useEffect(() => {
        props.successMsg(successMsg)
    }, [successMsg]);

    return (
        <>
            <Stack
                justifyContent="flex-start"
                alignItems="baseline"
                spacing={0.5}>
                <Grid container spacing={2}>
                    <Grid item xs={5}>
                        <label className="min-w-fit">*Customer Name</label>
                    </Grid>
                    <Grid item xs={3}>
                        <Select
                            name="name"
                            className=" min-w-[150px]"
                            value={(lcData.company && companyOptions.length > 0) && companyOptions.filter((list) => list.id === lcData.company)}
                            onChange={handleNameChange}
                            options={companyOptions}
                            isDisabled={props.viewData ? true : ammendDisabled}
                            styles={customStyles('', '', '0px')}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            value={lcData.company}
                            name="customer"
                            disabled
                            inputProps={{
                                sx: { 'padding': '10px' },
                            }}

                        />
                    </Grid>
                </Grid>

                {props.type === 'Ammend' ? <Grid container spacing={2}>
                    <Grid item xs={5}>
                        <label className="min-w-fit">*Documentary Credit No</label>
                    </Grid>
                    <Grid item xs={3}>
                        {((props.selectedRow && props.selectedRow.length > 0) || props.addSelected) ? <TextField
                            value={(props.selectedRow && props.selectedRow.length > 0) ? props.selectedRow[0].documentCreditNo : lcData.documentCreditNo}
                            name="customer"
                            disabled
                            inputProps={{
                                sx: { 'padding': '10px' },
                            }}

                        /> : <Select
                            name="name"
                            className=" min-w-[150px]"
                            value={(lcData.documentCreditNo && lcNumberOptions.length > 0) && lcNumberOptions.filter((list) => list.value === lcData.documentCreditNo)}
                            onChange={handleLcChange}
                            isDisabled={props.viewData ? true : ammendDisabled}
                            options={lcNumberOptions}
                            styles={customStyles('', '', '0px')} />}
                    </Grid>
                    <Grid item xs={3}>
                        <FormControl ></FormControl>
                    </Grid>
                </Grid> :
                    <Grid container spacing={2}>
                        <Grid item xs={5}>
                            <label className="min-w-fit">*Documentary Credit No</label>
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                value={lcData.documentCreditNo}
                                disabled={props.viewData ? true : ammendDisabled}
                                onChange={(e) => setLcData({ ...lcData, documentCreditNo: e.target.value })}
                                name="dc_no"
                                inputProps={{
                                    sx: { 'padding': '10px' },
                                }}

                            />
                        </Grid>
                    </Grid>
                }

                <Grid container spacing={2}>
                    <Grid item xs={5}>
                        <label className="min-w-fit">*Order Type</label>
                    </Grid>
                    <Grid item xs={6}>
                        <Select
                            name="orderType"
                            className=" w-[218px]"
                            value={(lcData.orderType && orderCategoriesOptions.length > 0) && orderCategoriesOptions.filter((list) => list.value === lcData.orderType)}
                            onChange={handleOrderTypeChange}
                            options={orderCategoriesOptions}
                            styles={customStyles('', '', '0px')}
                            isDisabled={props.viewData ? true : ammendDisabled}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2}>
                    <Grid item xs={5}>
                        <label className="min-w-fit">*{ammendDisabled ? 'Top Up' : 'Dc Amount'}</label>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            value={lcData.dcAmount}
                            name="dc_amount"
                            disabled={props.viewData ? true : false}
                            onChange={(e) => { handleDCAmountChange(e); setValidError(checkNumber(e.target.value)) }}
                            inputProps={{
                                sx: { 'padding': '10px', 'text-align': 'end' },
                            }}
                            helperText={validError}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={5}>
                        <label className="min-w-fit">*Tolerance Level</label>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            value={lcData.toleranceLevel}
                            disabled={props.viewData ? true : ammendDisabled}
                            name="tolerance_level"
                            className="w-[56%]"
                            onChange={(e) => { handleChangeToleranceLevel(e); setValidError(checkNumber(e.target.value)) }}
                            inputProps={{
                                sx: { 'padding': '10px' },
                            }}
                            helperText={validError}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">%</InputAdornment>,
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={5}>
                        <label className="min-w-fit">*Tolerance Amount</label>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            value={lcData.toleranceAmount}
                            name="tolerance_amount"
                            disabled
                            inputProps={{
                                sx: { 'padding': '10px', 'text-align': 'end' },
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={5}>
                        <label className="min-w-fit">Total DC Amount</label>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            value={lcData.totalDCAmount}
                            name="total_dc_amount"
                            disabled
                            inputProps={{
                                sx: { 'padding': '10px', 'text-align': 'end' },
                            }}
                        />
                    </Grid>
                </Grid>
                {ammendDisabled ?
                    <Grid container spacing={2}>
                        <Grid item xs={5}>
                            <label className="min-w-fit">*Date of Ammendment</label>
                        </Grid>
                        <Grid item xs={6}>
                            <CustomDatePicker
                                className={'mb-0'}
                                format={'dd-MM-yyyy'}
                                name={'date_of_issue'}
                                value={lcData?.dateOfAmmendment}
                                handleChange={(e) => setLcData({ ...lcData, dateOfAmmendment: moment(e).format('YYYY-MM-DD') })}
                                componentsProps={{
                                    actionBar: { actions: ["clear"] },
                                }}
                                disabled={props.viewData ? true : false}
                                renderInput={(params) => <TextField size="small" InputLabelProps={{
                                }} {...params} sx={{
                                    backgroundColor: props.viewData && '#8080800f',
                                    padding: 10
                                }}
                                />}
                            />
                        </Grid>
                    </Grid>
                    : <Grid container spacing={2}>
                        <Grid item xs={5}>
                            <label className="min-w-fit">*Date Of Issue</label>
                        </Grid>
                        <Grid item xs={6}>
                            <CustomDatePicker
                                className={'mb-0'}
                                format={'dd-MM-yyyy'}
                                name={'date_of_issue'}
                                value={lcData.dateOfIssue}
                                handleChange={(e) => setLcData({ ...lcData, dateOfIssue: moment(e).format('YYYY-MM-DD') })}
                                componentsProps={{
                                    actionBar: { actions: ["clear"] },
                                }}
                                disabled={props.viewData ? true : false}
                                renderInput={(params) => <TextField size="small" InputLabelProps={{
                                }} {...params} sx={{
                                    backgroundColor: props.viewData && '#8080800f',
                                    padding: 10
                                }}
                                />}
                            />
                        </Grid>
                    </Grid>}
                <Grid container spacing={2}>
                    <Grid item xs={5}>
                        <label className="min-w-fit">*Expiry Date</label>
                    </Grid>
                    <Grid item xs={6}>
                        <CustomDatePicker
                            className={'mb-0'}
                            format={'dd-MM-yyyy'}
                            name={'expiry_date'}
                            minDate={new Date(lcData?.dateOfIssue)}
                            value={lcData.expiryDate}
                            handleChange={(e) => setLcData({ ...lcData, expiryDate: moment(e).format('YYYY-MM-DD') })}
                            componentsProps={{
                                actionBar: { actions: ["clear"] },
                            }}
                            disabled={props.viewData ? true : false}
                            renderInput={(params) => <TextField size="small" InputLabelProps={{
                            }} {...params} sx={{
                                backgroundColor: props.viewData && '#8080800f'
                            }}
                            />}
                        />
                        <Typography className="text-[#f44336] text-sm ml-14">{new Date(lcData?.dateOfIssue) > new Date(lcData?.expiryDate) && "Expiry Date is always grater than date of Issue."}</Typography>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={5}>
                        <label className="min-w-fit">*Last Date Of Shipment</label>
                    </Grid>
                    <Grid item xs={6}>
                        <CustomDatePicker
                            className={'mb-0'}
                            format={'dd-MM-yyyy'}
                            name={'shipment'}
                            value={lcData.lastDateOfShipment}
                            minDate={new Date(lcData?.dateOfIssue)}
                            handleChange={(e) => setLcData({ ...lcData, lastDateOfShipment: moment(e).format('YYYY-MM-DD') })}
                            componentsProps={{
                                actionBar: { actions: ["clear"] },
                            }}
                            disabled={props.viewData ? true : false}
                            renderInput={(params) => <TextField size="small" InputLabelProps={{
                            }} {...params} sx={{
                                backgroundColor: props.viewData && '#8080800f'
                            }}
                            />}
                        />
                        <Typography className="text-[#f44336] text-sm ml-14">{new Date(lcData?.dateOfIssue) > new Date(lcData?.lastDateOfShipment) && "Last Date Of Shipment Date is always grater than date of Issue."}</Typography>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={5}>
                        <label className="min-w-fit">*Bank</label>
                    </Grid>
                    <Grid item xs={6}>
                        <Select
                            name="bank"
                            isDisabled={props.viewData ? true : ammendDisabled}
                            className=" min-w-[150px]"
                            value={(lcData.bank && bankOption.length > 0) && bankOption.filter((list) => list.value === lcData.bank)}
                            onChange={handleBankChange}
                            options={bankOption}
                            styles={customStyles('', '', '0px')}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={5}>
                        <label className="min-w-fit">*USANCE</label>
                    </Grid>
                    <Grid item xs={6}>
                        <Select
                            name="usance"
                            isDisabled={props.viewData ? true : ammendDisabled}
                            className=" min-w-[150px]"
                            value={(lcData.usance && usanceOption.length > 0) && usanceOption.filter((list) => list.id === lcData.usance || list.idUrl === lcData.usance)}
                            onChange={handleUsanceChange}
                            options={usanceOption}
                            styles={customStyles('', '', '0px')}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={5}>
                        <label className="min-w-fit">Issuing Bank Name</label>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            value={lcData.issuingBankName}
                            // disabled={props.viewData ? true : ammendDisabled}
                            disabled={true}
                            name="issuingbankname"
                            onChange={(e) => setLcData({ ...lcData, issuingBankName: e.target.value })}
                            inputProps={{
                                sx: { 'padding': '10px' },
                            }}

                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={5}>
                        <label className="min-w-fit">Bank Address</label>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            value={lcData.bankAddress}
                            // disabled={props.viewData ? true : ammendDisabled}
                            disabled={true}
                            name="bank_address"
                            onChange={(e) => setLcData({ ...lcData, bankAddress: e.target.value })}
                            inputProps={{
                                sx: { 'padding': '10px' },
                            }}

                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={5}>
                        <label className="min-w-fit">Bank Identifier Code</label>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            value={lcData.bankIdentifierCode}
                            // disabled={props.viewData ? true : ammendDisabled}
                            disabled={true}
                            name="identifier_code"
                            onChange={(e) => setLcData({ ...lcData, bankIdentifierCode: e.target.value })}
                            inputProps={{
                                sx: { 'padding': '10px' },
                            }}

                        />
                    </Grid>
                </Grid>
            </Stack>

        </>
    )
})
export default LetterOfCreditForm